import React from 'react';
import styled from 'styled-components';
import indents from '../../../../../../../constants/js/indents.js';
const StyledContainer = styled.div.withConfig({
  componentId: "index__sc-adr9ko-0"
})(["width:100%;padding-left:", ";padding-right:", ";padding-top:", ";padding-bottom:", ";"], ({
  isLeftIndent
}) => isLeftIndent ? indents.indentS : 0, ({
  isRigntIndent
}) => isRigntIndent ? indents.indentS : 0, indents.indentXS, indents.indentXS);
export const BoxIndent = ({
  children,
  isLeftIndent,
  isRigntIndent
}) => {
  return React.createElement(StyledContainer, {
    isLeftIndent: isLeftIndent,
    isRigntIndent: isRigntIndent
  }, children);
};